// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-components-bot-semi-src-components-ui-table-index-module__table-wrapper-q9Ku5h {
  flex-direction: column;
  height: 100%;
  display: flex;
}

.\\------packages-components-bot-semi-src-components-ui-table-index-module__spin-container-Vk9H0l {
  justify-content: center;
  align-items: center;
  height: 100%;
  display: flex;
}

.\\------packages-components-bot-semi-src-components-ui-table-index-module__table-list-VIeW9x {
  flex: 1;
  margin-top: 12px;
}

.\\------packages-components-bot-semi-src-components-ui-table-index-module__table-list-VIeW9x .semi-table-tbody > .semi-table-row {
  color: var(--light-usage-text-color-text-2, rgba(28, 29, 35, .6));
  cursor: pointer;
  background: #f7f7fa;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
}

.\\------packages-components-bot-semi-src-components-ui-table-index-module__table-list-VIeW9x .semi-table-tbody > .semi-table-row > .semi-table-cell-fixed-left {
  color: var(--light-usage-text-color-text-2, rgba(28, 29, 35, .6));
  cursor: pointer;
  background: #f7f7fa;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
}

.\\------packages-components-bot-semi-src-components-ui-table-index-module__table-list-VIeW9x .semi-table-tbody > .semi-table-row > .semi-table-cell-fixed-right {
  color: var(--light-usage-text-color-text-2, rgba(28, 29, 35, .6));
  cursor: pointer;
  background: #f7f7fa;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
}

.\\------packages-components-bot-semi-src-components-ui-table-index-module__table-list-VIeW9x .semi-table-thead > .semi-table-row > .semi-table-row-head.semi-table-cell-fixed-left:before {
  color: var(--light-usage-text-color-text-2, rgba(28, 29, 35, .6));
  cursor: pointer;
  background: #f7f7fa;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
}

.\\------packages-components-bot-semi-src-components-ui-table-index-module__table-list-VIeW9x .semi-table-thead > .semi-table-row > .semi-table-row-head.semi-table-cell-fixed-right:before {
  color: var(--light-usage-text-color-text-2, rgba(28, 29, 35, .6));
  cursor: pointer;
  background: #f7f7fa;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
}

.\\------packages-components-bot-semi-src-components-ui-table-index-module__table-list-VIeW9x .semi-table-thead > .semi-table-row > .semi-table-row-head {
  border-bottom: 1px solid var(--light-usage-border-color-border, rgba(28, 29, 35, .08));
  color: var(--light-usage-text-color-text-1, rgba(28, 29, 35, .8));
  background: #f7f7fa;
  font-size: 12px;
  font-weight: 600;
}

.\\------packages-components-bot-semi-src-components-ui-table-index-module__table-list-VIeW9x .semi-table-tbody > .semi-table-row > .semi-table-row-cell {
  padding: 20px;
}

.\\------packages-components-bot-semi-src-components-ui-table-index-module__table-list-VIeW9x .semi-spin-block.semi-spin {
  height: 100%;
}

.\\------packages-components-bot-semi-src-components-ui-table-index-module__table-list-VIeW9x .semi-table-row-cell {
  padding: 16px !important;
}

.\\------packages-components-bot-semi-src-components-ui-table-index-module__table-list-VIeW9x .semi-table-fixed-header table {
  height: 41px;
}

.\\------packages-components-bot-semi-src-components-ui-table-index-module__tableListHoverStyle-zL2gLm .semi-table-row:hover > .semi-table-row-cell:before {
  content: "";
  background-color: #f7f7fa;
  width: 100%;
  height: 1px;
  position: absolute;
  top: -1px;
  left: 0;
}

.\\------packages-components-bot-semi-src-components-ui-table-index-module__tableListHoverStyle-zL2gLm .semi-table-row:hover > .semi-table-row-cell {
  background: var(--light-usage-fill-color-fill-0, rgba(46, 47, 56, .05)) !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0) !important;
}

.\\------packages-components-bot-semi-src-components-ui-table-index-module__tableListHoverStyle-zL2gLm .semi-table-row:hover > .semi-table-row-cell:first-child {
  border-top-left-radius: 8px !important;
  border-bottom-left-radius: 8px !important;
}

.\\------packages-components-bot-semi-src-components-ui-table-index-module__tableListHoverStyle-zL2gLm .semi-table-row:hover > .semi-table-row-cell:last-child {
  border-top-right-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
}

.\\------packages-components-bot-semi-src-components-ui-table-index-module__empty-content-d7M17Q {
  flex: 1;
  justify-content: center;
  align-items: center;
  display: flex;
}

.\\------packages-components-bot-semi-src-components-ui-table-index-module__empty-content-d7M17Q .semi-empty-footer {
  justify-content: center;
  display: flex;
}

.\\------packages-components-bot-semi-src-components-ui-table-index-module__indicator-Td83sL {
  text-align: center;
  color: rgba(28, 31, 35, .6);
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 64px;
  line-height: 64px;
  display: flex;
}

.\\------packages-components-bot-semi-src-components-ui-table-index-module__indicator-loading-vZ39Q4 {
  color: #4062ff;
  margin-right: 8px;
  animation: .8s linear infinite \\------packages-components-bot-semi-src-components-ui-table-index-module__rotation-t5HR3R;
}

@keyframes \\------packages-components-bot-semi-src-components-ui-table-index-module__rotation-t5HR3R {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(359deg);
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table-wrapper": `------packages-components-bot-semi-src-components-ui-table-index-module__table-wrapper-q9Ku5h`,
	"tableWrapper": `------packages-components-bot-semi-src-components-ui-table-index-module__table-wrapper-q9Ku5h`,
	"spin-container": `------packages-components-bot-semi-src-components-ui-table-index-module__spin-container-Vk9H0l`,
	"spinContainer": `------packages-components-bot-semi-src-components-ui-table-index-module__spin-container-Vk9H0l`,
	"table-list": `------packages-components-bot-semi-src-components-ui-table-index-module__table-list-VIeW9x`,
	"tableList": `------packages-components-bot-semi-src-components-ui-table-index-module__table-list-VIeW9x`,
	"tableListHoverStyle": `------packages-components-bot-semi-src-components-ui-table-index-module__tableListHoverStyle-zL2gLm`,
	"empty-content": `------packages-components-bot-semi-src-components-ui-table-index-module__empty-content-d7M17Q`,
	"emptyContent": `------packages-components-bot-semi-src-components-ui-table-index-module__empty-content-d7M17Q`,
	"indicator": `------packages-components-bot-semi-src-components-ui-table-index-module__indicator-Td83sL`,
	"indicator-loading": `------packages-components-bot-semi-src-components-ui-table-index-module__indicator-loading-vZ39Q4`,
	"indicatorLoading": `------packages-components-bot-semi-src-components-ui-table-index-module__indicator-loading-vZ39Q4`,
	"rotation": `------packages-components-bot-semi-src-components-ui-table-index-module__rotation-t5HR3R`
};
export default ___CSS_LOADER_EXPORT___;
